import * as types from '../constants/ActionTypes';

export const initialState = {
    exercisesId: []
};

export default function favouriteExercises(state = initialState, action = {}) {
    switch (action.type) {
        case types.ADD_EXERCISE_TO_FAVOURITE_SUCCESS:
            return {
                ...state,
                exercisesId: action.result
            };
        case types.GET_FAVOURITE_EXERCISES_SUCCESS:
            return {
                ...state,
                exercisesId: action.result
            };
        case types.REMOVE_EXERCISE_FROM_FAVOURITE_SUCCESS:
            return {
                ...state,
                exercisesId: action.result
            };
        default:
            return state;
    }
}
